import state from "frontend/state/main"

export default () => {
  state.AJAX_REQUEST_CACHE = {}
}
